import { getFromCache } from "../../../../../shared/data";

export const getPicklist = (name) => {
    return getFromCache(`/picklists/${name}`);
};

export const isNewTemplate = (version) => version === "v2" || version === null;
